import webfontLoader from 'webfontloader';

/**
 * Leverage the webfontloader if a configuration is provided.
 * @param fonts {Font[]} the font family or families to define
 * @param variants {Variant[]} the variant to define
 * @param formats {Format[]} the format(s) to define
 * @param loaderConfig {WebFont.Config} configuration object to invoke webfontloader with
 * @returns {void}
 *
 * [1] Construct our custom families key, which we will always use in favor of what a user specifies.
 * [2] Merge the user-provided config with our custom key
 * [3] Invoke the loader
 */

var loadSecondaryFonts = function loadSecondaryFonts(fonts, variants, formats, loaderConfig) {
  var families = []; // [1]

  fonts.forEach(function (font) {
    //get all the variants as a single string
    var fontVariants = variants.join(','); //add the font name along with the variants

    families.push(font + ":" + fontVariants);
  });
  var overrideConfig = {
    custom: {
      families: [families.join(',')]
    }
  }; // [2]

  var config = Object.assign({}, loaderConfig, overrideConfig); // [3]

  webfontLoader.load(config);
};

export default loadSecondaryFonts;
